import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.to ? `https://hd-uncensored-guide.readdy.site${item.to}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            {item.to && index < items.length - 1 ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800' : ''}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}